import React from 'react'
import Design from './Design.js'
const App = () => {
    return (
        <div>
            <Design/>
        </div>
    )
}

export default App
